var parse = require('../parse/index.js');
/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */


function isWeekend(dirtyDate) {
  var date = parse(dirtyDate);
  var day = date.getDay();
  return day === 0 || day === 6;
}

module.exports = isWeekend;